// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"Table_tableContainer__3vy-B","cell":"Table_cell__3YP-p"};